import {
  UpdateFeedbackMatchUrl,
  UpdateFeedbackNotesUrl,
  CreateUpdateFeedbackMediaUrl,
  DeleteFeedbackMediaUrl,
  CreateFavoriteUrl
} from '../utils/clientUrls'
import {
  genericPostRequestToApi,
  genericGetRequestToApi,
  genericDeleteRequestToApi,
  genericPutRequestToApi } from '../utils/genericRequests'

const defaultWantNeed = {
  wants: null,
  wantsMatch: 0,
  needs: null,
  needsMatch: 0
}

const matchItem = (type, item, array) => {
  const updatedArray = [...array]
  const index = updatedArray.findIndex(need => need.name === item.name)

  updatedArray[index] = {
    match: !item.match,
    name: item.name,
    wantNeed: type
  }

  return updatedArray
}

const updateNeeds = (item, wantNeedData) => {
  const immutable = { ...wantNeedData }
  const array = matchItem('Need', item, immutable.needs)
  immutable.needs = array

  if (item.match) {
    immutable.needsMatch = immutable.needsMatch - 1
  } else {
    immutable.needsMatch = immutable.needsMatch + 1
  }

  return immutable
}

const updateWants = (item, wantNeedData) => {
  const immutable = { ...wantNeedData }
  const array = matchItem('Want', item, immutable.wants)
  immutable.wants = array

  if (item.match) {
    immutable.wantsMatch = immutable.wantsMatch - 1
  } else {
    immutable.wantsMatch = immutable.wantsMatch + 1
  }

  return immutable
}

const getFeedbackObjectFromProperty = (home, preferences) => {
  const defaultFeedback = {
    wants: preferences.filter(pref => pref.wantNeed === 'Want'),
    wantsMatch: 0,
    needs: preferences.filter(pref => pref.wantNeed === 'Need'),
    needsMatch: 0
  }

  if (home.feedback.match) {
    const feedbackWantNeedList = home.feedback.match.results

    feedbackWantNeedList.map(pref => {
      const prefIndex = preferences.findIndex(obj => obj.name === pref.name && obj.wantNeed === pref.wantNeed)
      if (prefIndex >= 0 && pref.match) {
        pref.wantNeed === 'Want' ? defaultFeedback.wantsMatch++ : defaultFeedback.needsMatch++
        preferences[prefIndex].match = true
      }
    })

    defaultFeedback.wants = preferences.filter(pref => pref.wantNeed === 'Want')
    defaultFeedback.needs = preferences.filter(pref => pref.wantNeed === 'Need')
  }

  return defaultFeedback
}

const saveFeedback = async (profileId, homeId, { newImages, removedImagesIndexes, wants, needs, notes }) => {
  let requests = []

  requests.push(updateFeedbackWantsNeedsRequest(
    profileId,
    homeId,
    [...wants, ...needs]
  ))

  // Check if any image is added, then update media object
  if (newImages) {
    const imageFormData = new FormData()
    for (let i = 0; i < newImages.length; i++) {
      imageFormData.append('upload', newImages[i].newFile)
    }
    requests.push(addNewFeedbackImagesRequest(profileId, homeId, imageFormData))
  }

  // Check if any image is removed, then send delete request
  if (removedImagesIndexes) {
    for (const deleteIndex of removedImagesIndexes) {
      await removeFeedbackImageByIndex(profileId, homeId, deleteIndex)
    }
  }

  try {
    await Promise.all(requests)
    if (notes) {
      await updateFeedbackNotesRequest(profileId, homeId, notes)
    }
    const updatedProfile = await genericGetRequestToApi(CreateFavoriteUrl(profileId, homeId))
    return updatedProfile
  } catch (err) {
    throw new Error(err)
  }
}

const updateFeedbackWantsNeedsRequest = (profileId, homeId, wantsNeeds) => {
  return genericPutRequestToApi(
    UpdateFeedbackMatchUrl(profileId, homeId),
    { results: wantsNeeds }
  )
}

const updateFeedbackNotesRequest = (profileId, homeId, notes) => {
  return genericPutRequestToApi(
    UpdateFeedbackNotesUrl(profileId, homeId),
    { notes }
  )
}

const addNewFeedbackImagesRequest = (profileId, homeId, imageFormData) => {
  return genericPostRequestToApi(
    CreateUpdateFeedbackMediaUrl(
      profileId,
      homeId
    ),
    imageFormData
  )
}

const removeFeedbackImageByIndex = (profileId, homeId, index) => {
  return genericDeleteRequestToApi(
    DeleteFeedbackMediaUrl(
      profileId,
      homeId,
      index
    )
  )
}

export {
  matchItem,
  updateWants,
  updateNeeds,
  saveFeedback,
  getFeedbackObjectFromProperty,
  defaultWantNeed
}
